export default __webpack_public_path__ + "static/media/Mastercard.c778fe6a.svg";